// Stock: the weekly UT count. Each team counts the UT stock on its van once a
// week. The count is due Friday to Monday, and it belongs to the NEW week:
// Friday 30/10 (week 44) to Monday 02/11 (week 45) is the week 45 count. A
// team can count on any day; Tuesday to Thursday counts for the week running. Weeks are ISO weeks, named by their Monday.
// Days are UK dates as YYYY-MM-DD (todayUk).

const DAY = 86_400_000;
const utc = (day) => new Date(`${day}T12:00:00Z`);
const iso = (d) => d.toISOString().slice(0, 10);
const addDays = (day, n) => iso(new Date(utc(day).getTime() + n * DAY));
// 1 = Monday ... 7 = Sunday
const weekday = (day) => ((utc(day).getUTCDay() + 6) % 7) + 1;

export const isDay = (v) => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v) && !Number.isNaN(utc(v).getTime()) && iso(utc(v)) === v;

// The Monday of the ISO week a day is in.
export function weekMonday(day) {
  return addDays(day, 1 - weekday(day));
}

// ISO week number and its year (the year its Thursday falls in).
export function isoWeek(monday) {
  const thursday = utc(addDays(weekMonday(monday), 3));
  const year = thursday.getUTCFullYear();
  const dayOfYear = Math.round((thursday - utc(`${year}-01-01`)) / DAY) + 1;
  return { year, week: Math.floor((dayOfYear - 1) / 7) + 1 };
}

export function weekLabel(monday) {
  return `Week ${isoWeek(monday).week}`;
}

// The count week a count on this day is for: Friday to Sunday count for the
// next Monday's week, Monday to Thursday for their own.
export function countWeekFor(day) {
  const wd = weekday(day);
  return wd >= 5 ? addDays(day, 8 - wd) : weekMonday(day);
}

// Where things stand on a day: the week a count now is for, whether it's
// due (Friday to Monday), and that week's Friday-to-Monday.
export function countWindow(day) {
  const week = countWeekFor(day);
  const wd = weekday(day);
  return { due: wd === 1 || wd >= 5, week, opens: addDays(week, -3), closes: week };
}
